import React, {lazy, useEffect} from 'react';
import {Card, Grid, Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import Loadable from "../../../ui-component/Loadable";
import {useLocation} from "react-router-dom";
import AdUI from "../../../ui-component/AdUI";

const Menu = Loadable(lazy(() => import('./Menu')));

const useStyles = makeStyles({
    AppBar: {
        //marginTop: '7.5px',
        marginBottom: '32px',
        borderRadius: '0px !important'
    },
    headerLogo: {
        height: '120px'
    },
    line: {
        backgroundColor: '#4caf50',
        height: '1px',
        width: '75px',
        flex: 1
    },
    divLogo: {
        padding: '0 40px'
    }
});


export default function MainAppBar() {
    let location = useLocation();
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    useEffect(() => setValue(['/', 'streamer', '/about', '/contact', '/dcma', '/privacy'].indexOf(location.pathname)), [setValue, location.pathname]);

    return (
        <Card className={classes.AppBar}>
            <Grid item container alignItems="center" className={classes.headerLogo}>
                <Grid item className={classes.line}/>
                <Typography variant="h3" component="h1" className={classes.divLogo}>Boxing Streams</Typography>
                <Grid item className={classes.line}/>
            </Grid>
            <AdUI format="horizontal"/>
            <Menu value={value}/>
        </Card>
    );
}